import { Flex, Box, ChakraBadge, Stack, useTheme } from '@vitvio/design-system';
import { VitVioIcon } from '@vitvio/shared-components';
interface LayoutTopbarProps {
  children?: React.ReactNode;
  rightSection?: React.ReactNode;
  isInDemoMode?: boolean;
}

export function LayoutTopbar({ children, rightSection, isInDemoMode }: LayoutTopbarProps) {
  const { getColor, getSpacing } = useTheme();
  return (
    <Flex verticalAlign={'middle'} alignItems={'center'} justifyContent={'center'} padding={'0 8px'}>
      <Flex textAlign={'center'} w={'65px'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
        <VitVioIcon boxSize="8" my={getSpacing('3')} mx={getSpacing('4')} color={getColor('fg')} />
        {isInDemoMode && (
          <Stack
            direction="row"
            my="auto"
            width={'100%'}
            mx={'auto'}
            textAlign={'center'}
            display={'inline-block'}
            marginTop={'-21px'}
          >
            <ChakraBadge colorScheme="yellow">Demo</ChakraBadge>
          </Stack>
        )}
      </Flex>

      <Box display={'flex'} gap={4} flex={1}>
        {children}
      </Box>
    </Flex>
  );
}
